module.exports = __webpack_public_path__ + "static/media/bioLinkedIcon-WhiteDropNew.c72aa049.png";